import { RootType } from "@/models/lookup-tables/lookup-tables.dto";
import { useLocationsContext } from "@/pages/configurations/locations/context/Location";
import { Location } from "@/pages/configurations/locations/models/Location/Location";
import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useMemo } from "react";
import { useRootContext } from "../../../context/RootContext";
import { useRootStateContext } from "../../../context/RootStateContext";
import { RootState } from "../../../models/RootState/RootState";

type Props = {
	/*  gridRef:Function, */
	setRootIdForEdit: Function;
	setModalEditRoot: Function;
	setRootIdForDelete: Function;
	setModalDeleteRoot: Function;
	setCommentsModal: Function;
};

export const useTableData = ({
	setRootIdForEdit,
	setModalEditRoot,
	setRootIdForDelete,
	setModalDeleteRoot,
	setCommentsModal,
}: Props) => {
	const {
		state: { locations },
	} = useLocationsContext();
	const {
		state: { roots },
	} = useRootContext();
	const {
		state: { rootTypes },
	} = useRootTypeContext();
	const {
		state: { rootStates },
	} = useRootStateContext();

	const columns: ColDef[] = [
		{
			field: "rootId",
			headerName: "  ",
			width: 70,
		},
		{
			field: "rootName",
			headerName: "Name",
		},
		{
			field: "rootTypeId",
			headerName: "Root Type",
			filter: "agSetColumnFilter",
		},
		{
			field: "isActive",
			headerName: "Status",
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setRootIdForEdit(params.data.rootId);
										setModalEditRoot(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setRootIdForDelete(params.data.rootId);
										setModalDeleteRoot(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
		},
	];

	const defaultColDef = useMemo(
		() => ({
			innerWidth: "500px",
			resizable: true,
			sortable: true,
			filter: true,
			suppressMenu: true,
		}),
		[],
	);

	const rows = roots.map(
		({
			rootId,
			rootName,
			rootTypeId,
			isActive,
			locationId,
			rootStateId,
			stateComments,
			needsAttention,
			attentionComments,
			supervisorInstructions,
			workerComments,
		}) => {
			const rootType: RootType | undefined = find(rootTypes, [
				"rootTypeId",
				rootTypeId,
			]);
			const rootState: RootState | undefined = find(rootStates, [
				"rootStateId",
				rootStateId,
			]);
			const location: Location | undefined = find(locations, [
				"locationId",
				locationId,
			]);

			return {
				rootId,
				rootName,
				rootTypeId: rootType?.rootTypeName,
				isActive: isActive ? "Active" : "Inactive",
				locationId: location?.locationName,
				rootStateId: rootState?.rootStateName,
				stateComments,
				needsAttention: needsAttention ? "Yes" : "No",
				attentionComments,
				supervisorInstructions,
				workerComments,
				id: rootId,
			};
		},
	);
	return { rows, columns, defaultColDef };
};
